/**
 * ReworkWarningBadge - Inline warning indicator for jobs with pending rework
 *
 * Shows a small warning badge when a job has open rework issues.
 * Used in PA Queue, Assembly Queue, and job lists.
 */

export default function ReworkWarningBadge({ warnings = [], compact = false }) {
  if (!warnings || warnings.length === 0) return null;

  // Check if any are scrap
  const hasScrap = warnings.some(w => w.severity === 'scrap');
  const hasRework = warnings.some(w => w.severity === 'requires_rework');

  if (compact) {
    // Just a small indicator dot
    return (
      <span
        className={`inline-block w-2 h-2 rounded-full ${hasScrap ? 'bg-red-500' : 'bg-amber-500'}`}
        title={`${warnings.length} rework issue(s)`}
      />
    );
  }

  // Full badge with label
  return (
    <span
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-xs font-medium ${
        hasScrap
          ? 'bg-red-100 text-red-700 border border-red-200'
          : 'bg-amber-100 text-amber-700 border border-amber-200'
      }`}
      title={warnings.map(w => `${w.issueLabel || w.issueType}`).join(', ')}
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
      {hasScrap ? 'SCRAP' : 'RW'}
    </span>
  );
}
